import { createFileRoute } from "@tanstack/react-router";
import { PersonalizationContainer } from "@/features/personalization";

export const Route = createFileRoute("/$store/_layout/personalization")({
	component: PersonalizationPage,
});

function PersonalizationPage() {
	return <PersonalizationContainer />;
}
